import { useEffect } from 'react'

const APP_NAME = 'Kleezy Admin'

export default function useDocumentTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME
  }, [pageTitle])
}
